import { render, staticRenderFns } from "./SpaceHolder.vue?vue&type=template&id=bf9fe8ba&scoped=true&"
import script from "./SpaceHolder.vue?vue&type=script&lang=js&"
export * from "./SpaceHolder.vue?vue&type=script&lang=js&"
import style0 from "./SpaceHolder.vue?vue&type=style&index=0&id=bf9fe8ba&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9fe8ba",
  null
  
)

export default component.exports